import commentListStore from '@modules/comment/comment-list-store';
import commentViewStore from '@modules/comment/comment-view-store';
import commentImporterStore from '@modules/comment/comment-importer-store';
import commentFormStore from '@modules/comment/comment-form-store';
import commentDestroyStore from '@modules/comment/comment-destroy-store';

export default {
  namespaced: true,

  modules: {
    destroy: commentDestroyStore,
    form: commentFormStore,
    list: commentListStore,
    view: commentViewStore,
    importer: commentImporterStore,
  },
};
